import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import InlineValue from '../InlineValue';
import helpers from './helpers';
import {
  elementsSelector,
  currentElementIdSelector,
} from '../../../reducers/elements';
import { relationshipsSelector } from '../../../reducers/relationships';
import AssignPredecessorsModal from '../../modals/AssignPredecessorModal/';

const DisplaySelector = createSelector(
  [currentElementIdSelector, elementsSelector, relationshipsSelector],
  (currentElementId, elements, relationships) => ({
    currentElementId,
    elements,
    relationships,
  }),
);

@connect(DisplaySelector)
export default class Display extends PureComponent {
  static propTypes = {
    currentElementId: PropTypes.string,
    elements: PropTypes.object,
    inlineTypeOptions: PropTypes.object,
    providesToConsumesFrom: PropTypes.object,
    relationships: PropTypes.object,
    toggleEditor: PropTypes.func,
    userMode: PropTypes.string,
    // value: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      showAssignPredecessorsModal: false,
      currentElementId: props.currentElementId,
    };
  }

  setSelectedElement = element => {
    if (element) {
      this.setState({ currentElementId: element.get('id') });
    }
  };

  toggleAssignPredecessorsModal = () => {
    const { currentElementId } = this.props;
    this.setState({
      showAssignPredecessorsModal: !this.state.showAssignPredecessorsModal,
      currentElementId,
    });
  };

  render = () => {
    const {
      currentElementId,
      elements,
      providesToConsumesFrom,
      relationships,
      toggleEditor,
      inlineTypeOptions,
      userMode,
      propertyKey,
      elementIds,
      multiEditElementType,
      wbsRelTypeId,
    } = this.props;

    const valueArray = helpers.getElementIdsfromRelationships(
      currentElementId,
      inlineTypeOptions,
      relationships,
      providesToConsumesFrom,
    );

    const assignPredecessorsButton =
      userMode !== 'reader' &&
      propertyKey === 'Predecessor' &&
      inlineTypeOptions &&
      inlineTypeOptions.relationship_direction === 'consumesFrom' ? (
        <React.Fragment>
          <i
            className="fa fa-pencil-square-o"
            style={{
              display: 'inline-block',
              marginRight: 10,
              verticalAlign: 'top',
            }}
            onClick={this.toggleAssignPredecessorsModal}
          />
          <AssignPredecessorsModal
            showModal={this.state.showAssignPredecessorsModal}
            handleCloseModal={this.toggleAssignPredecessorsModal}
            contentLabel="Assign Predecessors"
            currentElementId={this.state.currentElementId}
            elementIds={elementIds}
            multiEditElementType={multiEditElementType}
            relationshipDirection="consumesFrom"
            relationshipType={inlineTypeOptions['[RT]relationship_type']}
            relationships={relationships}
            tasklistCallback={this.setSelectedElement}
          />
        </React.Fragment>
      ) : null;

    const actualValues = valueArray.map((v, k) => {
      const e = elements.get(v);
      const wbsPath = helpers.getWbsPathStringFromRelationships(relationships, wbsRelTypeId, elements, v);
      let name = e ? e.get('name') : '';
      return wbsPath ? (
        <div style={{ display: 'block' }} key={k}>
          <div style={{
            display: 'inline-block',
            backgroundColor: '#ddd',
            // borderRadius: '8px',
            paddingLeft: '3px',
            paddingRight: '3px',
            margin: '3px',
          }} ref={(el) => {
            if (el) {
              el.style.setProperty('border-radius', '8px', 'important');
            }
          }}>
            {wbsPath}
          </div> › {name}
        </div>
      ) : (
        <div style={{ display: 'block' }} key={k}>
          {name}
        </div>
      );
    });

    const clickToEdit =
      userMode !== 'reader' ? (
        <span className="clickToEdit">Click to edit</span>
      ) : null;
    const displayValue =
      actualValues.length > 0 ? (
        <div style={{ display: 'inline-block' }}>{actualValues}</div>
      ) : (
        clickToEdit
      );

    return (
      <div>
        {!elementIds && assignPredecessorsButton}
        <InlineValue
          toggleEditor={toggleEditor}
          userMode={userMode}
          hasManyValues
        >
          {displayValue}
        </InlineValue>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/types/RelationshipSelect/Display.js